module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    attrs: {
      "sm": 12
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', {}, [_vm._v("Toimipaikat")])]), _vm._v(" "), _vm._l((_vm.officesByDistrict), function(office) {
    return _c('div', [_c('office', {
      attrs: {
        "office": office
      }
    })], 1)
  }), _vm._v(" "), _c('el-button', {
    staticClass: "add",
    attrs: {
      "type": "primary",
      "plain": true,
      "icon": "plus"
    },
    on: {
      "click": _vm.addOffice
    }
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b39f9c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Offices.vue
// module id = 451
// module chunks = 0